<template>
  <div>
    <v-dialog v-model="dialog" persistent="persistent" max-width="1000px">
      <v-card grid-list-md>
        <v-layout row align-center>
          <v-flex>
            <h1 class="title px-3">{{ $t("pageHeader.newTicket") }}</h1>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <v-btn icon flat fab small @click="close()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-card-text>
          <v-container class="pa-0" grid-list-lg="grid-list-lg">
            <v-layout row v-if="preSelectLocation">
              <v-flex xs12>
                <div>Location</div>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-autocomplete
                      :label="$t('labels.selectLocation')"
                      v-model="Ticket.storeID"
                      :items="stores"
                      autocomplete="autocomplete"
                      item-text="name"
                      item-value="id"
                      persistent-hint="persistent-hint"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <div>Contact Information</div>
                <v-layout row wrap>
                  <v-flex xs12 sm4="sm4">
                    <v-text-field
                      autofocus="autofocus"
                      v-model="Ticket.name"
                      :error-messages="contactNameErrors"
                      label="Contact Person*"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4="sm4">
                    <v-text-field
                      v-model="Ticket.phoneNumber"
                      label="Phone Number"
                      :error-messages="phoneNumberErrors"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4="sm4">
                    <v-text-field
                      v-model="Ticket.email"
                      label="Email Address"
                      :error-messages="emailAddressErrors"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <div>Source</div>
                <v-layout row wrap>
                  <v-flex xs12 sm3>
                    <v-autocomplete
                      :items="comboBoxByID(3).ComboBoxDetails"
                      :label="$t('labels.software')"
                      item-text="selector"
                      @change="versionCheck"
                      :error-messages="softwareErrors"
                      item-value="id"
                      v-model="Ticket.softwareID"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex v-if="showLanguage.length !== 0">
                    <v-autocomplete
                      :items="comboBoxByID(1).ComboBoxDetails"
                      :label="$t('labels.language')"
                      item-text="selector"
                      item-value="id"
                      v-model="Ticket.languageID"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex v-if="showPriority.length !== 0">
                    <v-autocomplete
                      :items="comboBoxByID(2).ComboBoxDetails"
                      :label="$t('labels.priority')"
                      item-text="selector"
                      item-value="id"
                      v-model="Ticket.priorityID"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex>
                    <v-autocomplete
                      :items="comboBoxByID(4).ComboBoxDetails"
                      :label="$t('labels.ticketType')"
                      item-text="selector"
                      item-value="id"
                      :error-messages="ticketTypeErrors"
                      v-model="Ticket.ticketTypeID"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex>
                    <v-autocomplete
                      :items="comboBoxByID(9).ComboBoxDetails"
                      :label="$t('labels.source')"
                      item-text="selector"
                      :error-messages="sourceErrors"
                      item-value="id"
                      v-model="Ticket.sourceID"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex v-if="showStatus.length !== 0">
                    <v-autocomplete
                      :items="comboBoxByID(6).ComboBoxDetails"
                      :label="$t('labels.status')"
                      item-text="selector"
                      item-value="id"
                      v-model="Ticket.statusID"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex v-if="showAssigned.length !== 0">
                    <v-autocomplete
                      v-model="Ticket.assignedToUserID"
                      :items="users"
                      :error-messages="assignedToErrors"
                      item-text="fullName"
                      item-value="userID"
                      :label="$t('labels.assignedTo')"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <div>Ticket Detail</div>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      counter="counter"
                      :error-messages="titleErrors"
                      v-model="Ticket.title"
                      label="Title*"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-textarea
                      counter="counter"
                      :error-messages="descriptionErrors"
                      v-model="Ticket.description"
                      :label="$t('labels.description')"
                    ></v-textarea>
                  </v-flex>
                  <v-flex v-if="showSolution.length !== 0">
                    <v-textarea
                      counter="counter"
                      v-model="Ticket.solution"
                      :label="$t('labels.solution')"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn-toggle class="elevation-0" v-model="showLanguage" multiple>
            <v-tooltip class="ml-1 pointer" bottom="bottom">
              <template v-slot:activator="{ on }">
                <v-btn flat class="ml-0" v-on="on">
                  <v-icon>mdi-translate</v-icon>
                </v-btn>
              </template>
              <span>Change Language (English is Default)</span>
            </v-tooltip>
          </v-btn-toggle>
          <v-btn-toggle class="elevation-0" v-model="showStatus" multiple>
            <v-tooltip class="ml-1 pointer" bottom="bottom">
              <template v-slot:activator="{ on }">
                <v-btn flat class="ml-0" v-on="on">
                  <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>Change Status (Default is In Progress)</span>
            </v-tooltip>
          </v-btn-toggle>
          <v-btn-toggle class="elevation-0" v-model="showPriority" multiple>
            <v-tooltip class="ml-1 pointer" bottom="bottom">
              <template v-slot:activator="{ on }">
                <v-btn flat class="ml-0" v-on="on">
                  <v-icon>mdi-priority-high</v-icon>
                </v-btn>
              </template>
              <span>Set Priority (Default is Low)</span>
            </v-tooltip>
          </v-btn-toggle>

          <v-btn-toggle class="elevation-0" v-model="showAssigned" multiple>
            <v-tooltip class="ml-1 pointer" bottom="bottom">
              <template v-slot:activator="{ on }">
                <v-btn flat class="ml-0" v-on="on">
                  <v-icon>mdi-account-multiple-plus-outline</v-icon>
                </v-btn>
              </template>
              <span>Assigne to someone else</span>
            </v-tooltip>
          </v-btn-toggle>

          <v-btn-toggle class="elevation-0" v-model="showSolution" multiple>
            <v-tooltip class="ml-1 pointer" bottom="bottom">
              <template v-slot:activator="{ on }">
                <v-btn flat class="ml-0" v-on="on">
                  <v-icon>mdi-lightbulb-outline</v-icon>
                </v-btn>
              </template>
              <span>Enter Solution</span>
            </v-tooltip>
          </v-btn-toggle>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat="flat" @click="close()">Close</v-btn>
          <v-btn color="blue darken-1" :loading="loading" dark="dark" @click="save()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="versionDialog" persistent="persistent" width="300">
      <v-card>
        <v-card-text>
          <v-layout column>
            <v-flex>
              <div>Did you check dropbox</div>
              <v-switch
                v-model="Ticket.dropbox"
                :label="`${Ticket.dropbox ? 'Yes' : 'No'}`"
              ></v-switch>
            </v-flex>
            <v-flex>
              <v-text-field v-model="Ticket.version" label="2.0 Version?" id="id"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat="flat" @click="closeVersion">Close</v-btn>
          <v-btn color="info" :disabled="!Ticket.version" @click="saveVersion">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import locationService from "../../Location/service.js";
import ticketService from "../service.js";
import userService from "../../User/service.js";
const { validationMixin } = require("vuelidate");
const { required, minLength, email, minValue } = require("vuelidate/lib/validators");

export default {
  props: {
    createDialog: {
      default: false
    },
    preSelectLocation: {
      default: false
    }
  },
  name: "create-ticket",
  data() {
    return {
      loading: false,
      dialog: false,
      stores: [],
      users: [],
      showLanguage: [],
      showPriority: [],
      showAssigned: [],
      showStatus: [],
      showSolution: [],
      versionDialog: false,
      Ticket: {
        title: null,
        dropbox: false,
        version: null,
        storeID: null,
        solution: null,
        description: null,
        name: null,
        phoneNumber: null,
        email: null,
        softwareID: null,
        ticketTypeID: null,
        languageID: 31,
        priorityID: 35,
        statusID: 48,
        assignedToUserID: null,
        reporterUserID: null,
        createdAt: new Date().toISOString(),
        dueDate: new Date().toISOString()
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    Ticket: {
      name: {
        required,
        minLength: minLength(2)
      },
      phoneNumber: {
        required
      },
      email: {
        email
      },
      title: {
        required,
        minLength: minLength(10)
      },
      description: {
        required,
        minLength: minLength(10)
      },
      sourceID: {
        required,
        minValue: minValue(1)
      },
      ticketTypeID: {
        required,
        minValue: minValue(1)
      },
      softwareID: {
        required,
        minValue: minValue(1)
      },
      assignedToUserID: {
        required,
        minValue: minValue(1)
      }
    }
  },
  computed: {
    ...mapGetters("global", ["comboBox", "comboBoxByID", "currentUser"]),
    ...mapGetters("location", ["location"]),
    contactNameErrors() {
      const errors = [];
      if (!this.$v.Ticket.name.$dirty) return errors;
      if (!this.$v.Ticket.name.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Ticket.name.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.Ticket.phoneNumber.$dirty) return errors;
      if (!this.$v.Ticket.phoneNumber.required) errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    emailAddressErrors() {
      const errors = [];
      if (!this.$v.Ticket.email.$dirty) return errors;
      if (!this.$v.Ticket.email.email) errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    },
    titleErrors() {
      const errors = [];
      if (!this.$v.Ticket.title.$dirty) return errors;
      if (!this.$v.Ticket.title.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Ticket.title.minLength) errors.push("Field must be at least 10 characters long");
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.Ticket.description.$dirty) return errors;
      if (!this.$v.Ticket.description.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Ticket.description.minLength)
        errors.push("Field must be at least 10 characters long");
      return errors;
    },
    assignedToErrors() {
      const errors = [];
      if (!this.$v.Ticket.assignedToUserID.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Ticket.assignedToUserID.minValue) errors.push("Pleaes user name");
      return errors;
    },
    ticketTypeErrors() {
      const errors = [];
      if (!this.$v.Ticket.ticketTypeID.$dirty) return errors;
      if (!this.$v.Ticket.ticketTypeID.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Ticket.ticketTypeID.minValue) errors.push("Pleaes select source");
      return errors;
    },
    sourceErrors() {
      const errors = [];
      if (!this.$v.Ticket.sourceID.$dirty) return errors;
      if (!this.$v.Ticket.sourceID.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Ticket.sourceID.minValue) errors.push("Pleaes select source");
      return errors;
    },
    softwareErrors() {
      const errors = [];
      if (!this.$v.Ticket.softwareID.$dirty) return errors;
      if (!this.$v.Ticket.softwareID.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Ticket.softwareID.minValue) errors.push("Pleaes select software");
      return errors;
    }
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
      if (this.preSelectLocation) {
        this.getActiveStore();
      }
      this.Ticket.storeID = this.location.storeID;
      this.getAllUsers();
      this.Ticket.assignedToUserID = this.currentUser.userID;
      this.Ticket.reporterUserID = this.currentUser.userID;
    }
  },
  methods: {
    saveVersion() {
      this.versionDialog = false;
    },
    closeVersion() {
      this.Ticket.softwareID = null;
      this.Ticket.version = null;
      this.Ticket.dropbox = false;
      this.versionDialog = false;
    },
    getAllUsers() {
      return userService.getAllCrmUser().then(result => {
        this.users = result.data;
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Ticket = {
        title: null,
        storeID: null,
        solution: null,
        description: null,
        name: null,
        phoneNumber: null,
        email: null,
        softwareID: null,
        ticketTypeID: null,
        languageID: 31,
        priorityID: 35,
        statusID: 48,
        assignedToUserID: null,
        reporterUserID: null,
        createdAt: new Date().toISOString(),
        dueDate: new Date().toISOString()
      };
      this.showLanguage = [];
      this.showPriority = [];
      this.showAssigned = [];
      this.showStatus = [];
      this.showSolution = [];
      this.$v.$reset;
    },
    versionCheck() {
      console.log("test", this.Ticket);
      if (this.Ticket.softwareID === 54) {
        this.versionDialog = true;
      } else {
        this.versionDialog = false;
      }
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        this.Ticket.storeID = this.location.storeID;
        this.Ticket.loginEmail = this.currentUser.loginEmail;
        console.log("saving", this.Ticket);
        if (this.Ticket.softwareID === 54) {
          if (!this.Ticket.version) {
            this.$swal(
              "Missing Value",
              "2.0 Software tickets you must enter version of software",
              "error"
            );
            return false;
          }
        }
        this.loading = true;
        return ticketService
          .create(this.Ticket)
          .then(result => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "success",
                  title: "Ticket is created"
                });
              this.empty();
              this.loading = false;
              this.$emit("created");
            }
          })
          .catch(err => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                type: "error",
                title: err.data.data
              });
          });
      }
    }
  }
};
</script>

<style scoped></style>
